import { groupMarketsByEvent } from './market-list/event-groups';
import type { EventMarketGroup } from './market-list/event-groups';
import { Market } from '@/libs/sdk/api';

// Must match the .saker-hero single-column breakpoint in saker-home.css —
// below it the deck is not rendered and the Trending rail keeps the top slots.
export const HERO_DECK_BREAKPOINT = 900;

/**
 * Hero deck (Market-Forward hero) shows standalone binary markets only.
 * Multi-market events render as EventCard grids elsewhere; in the compact
 * hero deck a single leg would read as the whole event (the same lone-leg
 * trap select-trending-section guards against), so grouped events are
 * skipped rather than flattened.
 */
export const selectHeroDeckMarkets = (markets: Market[]): Market[] =>
  groupMarketsByEvent(markets)
    .filter(group => group.markets.length === 1)
    .map(group => group.markets[0])
    .slice(0, 3);

/**
 * Trending-rail companion: drop the groups the hero deck already shows so the
 * two rails never render the same cards back to back. Only meaningful when the
 * deck is actually visible (desktop) — on mobile the deck is not rendered and
 * the rail must keep the top slots, so callers gate this on the breakpoint.
 */
export const excludeHeroDeckGroups = (groups: EventMarketGroup[], markets: Market[]): EventMarketGroup[] => {
  const deckAddresses = new Set(selectHeroDeckMarkets(markets).map(market => market.marketAddress));
  return groups.filter(group => !(group.markets.length === 1 && deckAddresses.has(group.markets[0].marketAddress)));
};
